import { gql } from '@apollo/client';

export const CREATE_DECISION_NODE = gql`
  mutation CreateDecisionNode($params: CreateDecisionNodeInput!) {
    createDecisionNode(params: $params) {
      success
      message
      errors
      data {
        id
        treeKey
        nodeKey
        nodeType
        messageTemplate
        options
        inputConfig
        dynamicOptionsConfig
        terminalConfig
        contextUpdates
        parentNodeKey
        nextNode
        nextNodeOnSelect
        requiresTenant
        displayOrder
        isActive
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;

export const UPDATE_DECISION_NODE = gql`
  mutation UpdateDecisionNode($params: UpdateDecisionNodeInput!) {
    updateDecisionNode(params: $params) {
      success
      message
      errors
      data {
        id
        treeKey
        nodeKey
        nodeType
        messageTemplate
        options
        inputConfig
        dynamicOptionsConfig
        terminalConfig
        contextUpdates
        parentNodeKey
        nextNode
        nextNodeOnSelect
        requiresTenant
        displayOrder
        isActive
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;

export const DELETE_DECISION_NODE = gql`
  mutation DeleteDecisionNode($params: DeleteDecisionNodeInput!) {
    deleteDecisionNode(params: $params) {
      success
      message
      errors
    }
  }
`;
